import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}

export const ModalVisualizarAplicar: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ textAlign: 'center', fontSize: '1.2em' }}>
        <p style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
          Verifica que tengas la sesión iniciada
        </p>
      </div>
    </Modal>
  );
};
